/** Effective price of one model (input / output USD per 1M tokens and its source) with a Set price action. */

import type { ReactElement } from 'react';
import type { AiModel } from '@services/aiModelsService';
import { useAiModelPrice } from '../hooks/useAiModels';
import { formatEffectivePrice } from '../utils/priceFormat';

interface AiModelPriceCellProps {
  model: AiModel;
  onEdit: () => void;
}

export function AiModelPriceCell({ model, onEdit }: AiModelPriceCellProps): ReactElement {
  const { data, isLoading, error } = useAiModelPrice(model.model_id);
  return (
    <div className="feature-table__actions-cell">
      <span
        data-testid={`price-${model.model_id}`}
        {...(error ? { title: error.message } : {})}
      >
        {isLoading ? '…' : error ? 'error' : formatEffectivePrice(data)}
      </span>
      <button
        type="button"
        className="feature-table__edit-btn"
        onClick={onEdit}
        aria-label={`Set price for ${model.model_id}`}
      >
        Set price
      </button>
    </div>
  );
}
